// analytics.js - PostHog Analytics Configuration

export const ANALYTICS_CONFIG = {
  apiKey: import.meta.env.VITE_POSTHOG_API_KEY,
  apiHost: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
  enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',

  // PostHog initialization options
  options: {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',

    // Disable autocapture to avoid noise - we'll track explicitly
    autocapture: false,

    // Disable automatic pageview tracking - we'll handle manually with React Router
    capture_pageview: false,

    // Enable page leave tracking
    capture_pageleave: true,

    // Session recording configuration
    session_recording: {
      enabled: true,
      recordCrossOriginIframes: false,

      // Don't mask all inputs by default (internal tool)
      maskAllInputs: false,

      // Mask elements with 'sensitive-data' class
      maskTextSelector: '.sensitive-data',
    },

    // Enable session recording
    disable_session_recording: false,

    // Capture console logs in session recordings
    enable_recording_console_log: true,

    // Callback when PostHog loads
    loaded: (posthog) => {
      if (import.meta.env.MODE === 'development') {
        console.log('PostHog analytics loaded');
      }
    }
  }
};

/**
 * Check if analytics is enabled and configured
 */
export const isAnalyticsEnabled = () => {
  return ANALYTICS_CONFIG.enabled && ANALYTICS_CONFIG.apiKey;
};
